module.exports = __webpack_public_path__ + "img/graduate2.a5a6772.svg";